import { useDispatch, useSelector } from "react-redux"
import { numberWithCommas } from "../../helpers/numbers"
import { UndertakingConsentModal } from "../Modals/UndertakingConsent/UndertakingConsent.Modal"
import { useState } from "react"
import { onboardFormActions } from "../../store/onboardFormState"
import { textWithFirstCharUpper, textWithOnlyUpper } from "../../helpers/string"

export const ReviewDetailsForm = ({diableButtons}) => {

    const dispatch = useDispatch()

    const formState = useSelector(state => state.onboardForm)

    const [undertakingModalState, setUndertakingModalState] = useState({
        isOpen: false,
        content: "",
        id: ""
    })

    const openModal = (id, content) => setUndertakingModalState((prevState) => ({
        isOpen: true,
        content: content,
        id: id
    }))

    const closeModal = () => setUndertakingModalState((prevState) => ({
        isOpen: false,
        content: "",
        id: ""
    }))


 const getFilteredDocuments = () => {
  const { documents, domains } = formState;



  // collect all selected services
  const selectedServices = domains.flatMap(
    d => d.subCategory || []
  );



  const isAuditSelected = selectedServices.some(service => {
    const serviceName = service.name?.toLowerCase() || "";

    const hasFinancial = serviceName.includes("audit");
    const hasAudit = serviceName.includes("assurance");

    return hasFinancial && hasAudit;
  });



  const filteredDocs = documents.filter(doc => {
    const shouldHide =
      doc.visibleForAuditOnly && !isAuditSelected;

    

    return !shouldHide;
  });


  return filteredDocs;
};
    return (
        <div>
            <div className="card card-grey review mb-3">
                <div className="card-body">
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                        Domain and Services Details
                    </p>
                    <table className="table">
                        <tbody>
                            {formState?.domains?.map((d, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td>
                                            <div className="font-12 opacity-70">{d.name}</div>
                                        </td>
                                        <td>
                                            <div className="font-12 font-weight-600">
                                                {d?.subCategory?.map((s) => <div key={s.id}>
                                                    {s.name} <br />
                                                </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                        Business Details
                    </p>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Trade license no.</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.tradeLicence != "" ? textWithOnlyUpper(formState.tradeLicence) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">VAT registration no.</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.vatRegistration != "" ? textWithOnlyUpper(formState.vatRegistration) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Applicant firm</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.nameOfApplicantFirm != "" ? textWithFirstCharUpper(formState.nameOfApplicantFirm) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Year of establishment</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.yearOfEstablishment != "" ? formState.yearOfEstablishment : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Office telephone</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">+{formState.officeTelephone != "" ? formState.officeTelephone : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Email address</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                        {formState.emailAddress != "" ? formState.emailAddress : "N/A"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Number of employees</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.numberOfEmployees != "" ? formState.numberOfEmployees : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Turnover (last year)</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.lastYearTurnover != "" ? "AED " + numberWithCommas(formState.lastYearTurnover) : "N/A"}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                        Address Details
                    </p>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Address</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">
                                        {formState.address != "" ? textWithFirstCharUpper(formState.address) : "N/A"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Area</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.area != "" ? textWithFirstCharUpper(formState.area) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">country</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.city != "" ? textWithFirstCharUpper(formState.city) : "N/A"}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                        Primary Contact Details
                    </p>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Designation</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.primaryContactDesignation != "" ? textWithFirstCharUpper(formState.primaryContactDesignation) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Name</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">{formState.primaryContactName != "" ? textWithFirstCharUpper(formState.primaryContactName) : "N/A"}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Email address</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600 eWidth">
                                        {formState.primaryContactEmail != "" ? formState.primaryContactEmail : "N/A"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="font-12 opacity-70">Phone number</div>
                                </td>
                                <td>
                                    <div className="font-12 font-weight-600">+{formState.primaryContactPhone != "" ? formState.primaryContactPhone : "N/A"}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="card card-grey review mb-3">
                <div className="card-body">
                    <p className="mb-1 font-16 font-weight-700 text-light-default">
                        Mandatory Documents
                    </p>
                    <table className="table">
                        <tbody>
  {getFilteredDocuments()
  .filter(d => d.docId !== "")
  .map((d, idx) => (
    <tr key={idx}>
      <td>
        <div className="font-12 opacity-70">
          {d.name}
        </div>
      </td>
      <td className="text-right">
        <a
          href={d.url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-12 text-light-default font-weight-600"
        >
          View document
        </a>
      </td>
    </tr>
))}
</tbody>
                    </table>
                    {
                        formState?.additionalDocuments?.length ? <div>
                            <p className="mb-1 font-16 font-weight-700 text-light-default">
                            Additional Documents
                            </p>
                            <table className="table">
                                <tbody>
                                    {formState.additionalDocuments.map((d, idx) => {
                                        if (d.docId != "") {
                                            return (
                                                <tr key={idx}>
                                                    <td>
                                                        <div className="font-12 opacity-70">
                                                            {textWithFirstCharUpper(d.name)} 
                                                        </div>
                                                    </td>
                                                    <td className="text-right">
                                                        <a href={d.url} target="_blank" className="font-12 text-light-default font-weight-600">
                                                            View document
                                                        </a>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })}
                                </tbody>
                            </table>
                        </div> : <div></div>
                    }
                </div>
            </div>
            <p className="font-20">Undertaking</p>
            <div className="row">
                {
                    formState.undertakings.map((u, idx) => {
                        return <div key={idx} className="col-12 col-md-12">
                            <div className="checkboxStyleTwo">
                                <input type="checkbox" id={u.id} readOnly checked={u.checked || diableButtons} onChange={(e) => e.target.checked ?
                                    // openModal(u.id, u.content)
                                    dispatch(onboardFormActions.checkUndertaking({ id: u.id, checked: true }))
                                    : dispatch(onboardFormActions.checkUndertaking({ id: u.id, checked: false }))
                                } />
                                <label htmlFor={u.id}>
                                    <span>{u.title}</span>
                                </label>
                            </div>
                        </div>
                    })
                }
            </div>
            {/* <UndertakingConsentModal id={undertakingModalState.id} show={undertakingModalState.isOpen} close={closeModal} content={undertakingModalState.content} /> */}
        </div>
    )
}